import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import Select from "react-select";
import styled from "styled-components";

import _ from "lodash";
import Schemas from "schemas";

import UserApi from "../../api/user-api";
import OECDs from "../../constants/OECDs.json";

import { Control } from "components/ui-kit/control";
import { AuthStyles, Button, PhotoDropzone } from "components/ui-kit/styled-templates";

import useFormControl from "hooks/useFormControl";
import { useStorageListener } from "hooks/useStorage";

import { EForms } from "types/enums";
import { resolveFileUrl } from "constants/config";

const StudentProfileIntoPage = () => {
    const { t, i18n } = useTranslation();
    let isRu = i18n.language === "ru";

    const [universities, setUniversities] = useState([]);
    const [selectedUniversity, setSelectedUniversity] = useState(null);

    const uData = useStorageListener("user", {});
    const { data, onSubmit, setValues } = useFormControl({
        name: EForms.studentProfileInfo,
        schema: Schemas.studentProfileInfo
    });
    const handlers = {
        submit: async (details) => {
            console.log("details = ", details);
            await UserApi.updateUser({
                id: uData.id,
                ...details,
                userUniversityId: selectedUniversity?.value || ""
            });
            window.alert(t("ea2f8og5y3m"));
            // await UniversityApi.updateMyUniversity({ id, details });
            // navigate(`/`);
        }
    };

    // Load universities list
    useEffect(() => {
        axios.get("/universities/all").then((response) => {
            setUniversities(response.data);
        }).catch((error) => {
            console.error("Error loading universities:", error);
        });
    }, []);

    // Initialize form values and selected university
    useEffect(() => {
        setValues(
            _.pick(uData, [
                "email",
                "name",
                "firstName",
                "lastName",
                "middleName",
                "gender",
                "departureCity",
                "phone",
                "socialUrl",
                "universityName",
                "avatar",
                "birthday",
                "WoS",
                "WoS1",
                "studentRoleType"
            ])
        );

        // Set selected university based on userUniversityId
        if (uData?.userUniversityId && universities.length > 0) {
            if (uData.userUniversityId === "other") {
                // Восстанавливаем выбор "Другое"
                setSelectedUniversity({
                    value: "other",
                    label: isRu ? "Другое" : "Other"
                });
            } else {
                const uni = universities.find(u => u.id === uData.userUniversityId);
                if (uni) {
                    const shortName = uni?.details?.shortName || "";
                    const fullName = uni?.details?.name || "";
                    const label = shortName && fullName
                        ? `${shortName} (${fullName})`
                        : shortName || fullName;
                    setSelectedUniversity({
                        value: uni.id,
                        label: label
                    });
                }
            }
        }
    }, [uData, universities, isRu]);

    console.log("EForms.studentProfileInfo = ", EForms.studentProfileInfo);
    console.log("EForms.uData = ", uData);
    let isAmbassador = (uData?.isAmbassador == true);

    // Prepare university options with format: "Short name (Full name)"
    const universityOptions = [
        ...universities
            .filter(uni => uni?.details?.shortName || uni?.details?.name)
            .map(uni => {
                const shortName = uni?.details?.shortName || "";
                const fullName = uni?.details?.name || "";
                const label = shortName && fullName
                    ? `${shortName} (${fullName})`
                    : shortName || fullName;
                return {
                    value: uni.id,
                    label: label
                };
            })
            .sort((a, b) => a.label.localeCompare(b.label, isRu ? 'ru' : 'en')),
        { value: "other", label: isRu ? "Другое" : "Other" }
    ];

    return (
        <AuthStyles.Container extra={`padding-left: 304px; padding-right: 304px; margin-bottom: 30px;`}>
            <h2>{t("s4z2vs41l1")}</h2>
            <p style={{marginTop: '4px'}} >{t("xgpm7m1p8k")}</p>

            {/*{isAmbassador == false ? null :*/}
            {/*    <div style={{marginBottom: 10, marginTop: 10, textAlign: 'center'}} >*/}
            {/*        {'Вы являетесь амбассадором.'}*/}
            {/*        <br/>*/}
            {/*        <a href={'/ambassador-profile'} style={{textDecoration: 'underline'}} >*/}
            {/*            перейти к настройкам амбассадора*/}
            {/*        </a>*/}
            {/*    </div>*/}
            {/*}*/}

            <Control.Form name={EForms.studentProfileInfo} onSubmit={onSubmit(handlers.submit)}>
                <Control.File name="avatar" accept="image/jpeg, image/png">
                    <PhotoDropzone
                        src={resolveFileUrl(data?.avatar)}
                                   label={'Загрузить фотографию (формат JPG, высота 600 пикселей, ширина 900 пикселей)'}

                    />
                </Control.File>
                <Control.Input name="email" placeholder="Email" label="Email" />



                <Control.Input name="name" placeholder={'Фамилия, Имя, Отчество'} label={'ФИО'} />

                {/*<Control.Input name="lastName" placeholder={t("9cmfqdljh4w")} label={t("7jsl0caa3rx")} />*/}
                {/*<Control.Input name="firstName" placeholder={t("ev55non7g98")} label={t("q01mf7jcb3")} />*/}
                {/*<Control.Input name="middleName" placeholder={t("59nim1irjsa")} label={t("7dwbehdm8gu")} />*/}

                <Control.Select
                    name="studentRoleType"
                    placeholder={t("signupStudentRole.label")}
                    label={t("signupStudentRole.label")}
                    options={[
                        { value: "student", label: t("signupStudentRole.student") },
                        { value: "youngSpecialist", label: t("signupStudentRole.youngSpecialist") },
                        { value: "youngScientist", label: t("signupStudentRole.youngScientist") }
                    ]}
                />

                <Control.Select
                    name="gender"
                    placeholder={t("9ou0ytf9au7")}
                    label={t("uxm1byzjuqj")}
                    options={[
                        { value: "male", label: t("euhc9cj4em7") },
                        { value: "female", label: t("kanvnouyxh") }
                    ]}
                    isRequired
                />

                <Control.Input name="birthday" placeholder={t("eijcqcyir7t")} label={t("hauzrh46cpr")} isRequired />

                {/*<Control.Date*/}
                {/*    name="birthday" label="Дата рождения" placeholder="Дата рождения" isRequired />*/}

                <Control.Input name="departureCity" placeholder={t("3qwllm663b")} label={t("jnmtr2ivl4g")} />
                <Control.Input name="phone" placeholder={t("gg1vecjy5e")} label={t("avsr1j3il5b")} />
                <Control.Input name="socialUrl" placeholder={t("8ehajndqq7r")} label={t("jhhmzgf8gih")} />

                <UniversitySelectWrapper>
                    <label>{t("rlan73py35c")}</label>
                    <Select
                        value={selectedUniversity}
                        onChange={setSelectedUniversity}
                        options={universityOptions}
                        placeholder={t("36wow8evojq")}
                        isClearable
                        isSearchable
                        styles={{
                            control: (base) => ({
                                ...base,
                                minHeight: '48px',
                                borderRadius: '4px',
                                borderColor: '#d9d9d9',
                            }),
                            menu: (base) => ({
                                ...base,
                                zIndex: 9999,
                            }),
                        }}
                    />
                </UniversitySelectWrapper>

                {/* Специализация скрыта по требованию
                <Control.Select
                    name="WoS"
                    label={t("7dx7opg45tp")}
                    options={OECDs.filter((i) => !_.isEmpty(i?.["WoS"])).map((i) => ({
                        ...i,
                        value: i?.["WoS"],
                        label: i?.["3_LevelRus"]
                    }))}
                    groupBy={["1_LevelRus", "2_LevelRus"]}
                    isRequired
                />
                */}

                {/* Дополнительная специализация скрыта по требованию
                <Control.Select
                    name="WoS1"
                    label={t("jk8dak0f1k")}
                    options={OECDs.filter((i) => !_.isEmpty(i?.["WoS"])).map((i) => ({
                        ...i,
                        value: i?.["WoS"],
                        label: i?.["3_LevelRus"]
                    }))}
                    groupBy={["1_LevelRus", "2_LevelRus"]}
                />
                */}

                {/*<Control.Textarea*/}
                {/*    name="name"*/}
                {/*    placeholder="Наименование образовательной организации"*/}
                {/*    label="Наименование образовательной организации"*/}
                {/*    isRequired*/}
                {/*/>*/}
                {/*<Control.Input name="shortName" placeholder="Краткое наименование ВУЗа" label="Короткое название" />*/}
                {/*<Control.Input name="founderName" placeholder="Наименование учредителя" label="Наименование учредителя" />*/}
                {/*<Control.Input name="site" placeholder="Ссылка" label="Укажите сайт образовательной организации" isRequired />*/}
                {/*<Control.Input*/}
                {/*    name="committee"*/}
                {/*    placeholder="Наименование организационного комитета"*/}
                {/*    label="Наименование организационного комитета"*/}
                {/*    isRequired*/}
                {/*/>*/}
                {/*<Control.Input name="region" placeholder="Субъект" label="Субъект" isRequired />*/}
                {/*<Control.Input name="city" placeholder="Город" label="Город" isRequired />*/}

                {/* <Control.Input name="reginLink" placeholder="Ссылка" label="Укажите сайт субъекта РФ  (необязательно)" /> */}
                {/* {!data?.campusesNumber && (
                    <>
                        <Control.Error extra={`height: max-content; text-align: center; margin-bottom: 1rem;`}>
                            Без указания кампусав, Вам доступно только бронирование жилья. Добавить кампусы вы сможете в любой момент
                        </Control.Error>
                    </>
                )} */}
                <Button type="submit" background="blue" extra={`width: 100%; padding: `}>
                    {t("jc874yzniri")}
                </Button>
            </Control.Form>
            <span style={{ marginTop: "1rem", textAlign: "center" }}>{t("j8q7q7q7q7q")}</span>

            <div style={{ height: 200 }}></div>
        </AuthStyles.Container>
    );
};

const UniversitySelectWrapper = styled.div`
    margin-bottom: 20px;

    label {
        display: block;
        margin-bottom: 8px;
        font-size: 14px;
        font-weight: 500;
        color: #333;
    }
`;

export default StudentProfileIntoPage;
